import React from 'react';
import EditableField from './EditableField';
import './AbilityScores.css';

const AbilityScores = ({ abilityScores, updateCharacter }) => {
  const getModifier = (score) => {
    return Math.floor((score - 10) / 2);
  };

  const handleIncrement = (ability) => {
    updateCharacter(['abilityScores', ability], abilityScores[ability] + 1);
  };

  const handleDecrement = (ability) => {
    updateCharacter(['abilityScores', ability], abilityScores[ability] - 1);
  };

  return (
    <div className="ability-scores">
      <h2>Ability Scores</h2>
      {Object.keys(abilityScores).map((ability) => (
        <div key={ability} className="ability-score">
          <div className="ability-name">{ability.charAt(0).toUpperCase() + ability.slice(1)}</div>
          <div className="ability-controls">
            <button onClick={() => handleDecrement(ability)}>-</button>
            <EditableField path={['abilityScores', ability]} value={abilityScores[ability]} updateCharacter={updateCharacter} />
            <button onClick={() => handleIncrement(ability)}>+</button>
          </div>
          <div className="ability-modifier">
            {getModifier(abilityScores[ability]) >= 0 ? '+' : ''}
            {getModifier(abilityScores[ability])}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AbilityScores;
